import AgreementsShow from './agreements/show'
import ContactsList from './contacts/list'
import ContactsShow from './contacts/show'
import ImportsList from './imports/list'
import ImportsShow from './imports/show'
import ListsList from './lists/list'
import ListsShow from './lists/show'

const routes = [
  { path: '/agreements/:id/:view', component: AgreementsShow },
  { path: '/contacts', component: ContactsList },
  { path: '/contacts/:id/:view', component: ContactsShow },
  { path: '/imports', component: ImportsList },
  { path: '/imports/:id/:view', component: ImportsShow },
  { path: '/lists', component: ListsList },
  { path: '/lists/:id/:view', component: ListsShow }
]

export default routes
